import { useEffect, useState } from 'react'

const useShowWithDelay = (delay = 500, enabled = true) => {
  const [visible, setVisible] = useState(delay === 0)

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delay)
    return () => clearTimeout(timer)
  }, [delay, enabled])

  return visible
}

export default useShowWithDelay
